module.exports = __webpack_public_path__ + "img/2preloader1228x492.485c8f87.gif";